import { Directive, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[selectableElement]'
})
export class SelectableElementDirective implements OnInit {

  @Input() set checked(value:boolean){
    this._isChecked = value;
    this.setDisplay();
  }
  private _isChecked:boolean = false;

  constructor(private el: ElementRef,private renderer: Renderer2) {

  }

  ngOnInit(): void {

    // create the mask div
    const mask = document.createElement('div');

    // const titleHolder = document.createElement('div');
    // title.innerHTML = this.maskedText;
    mask.innerHTML = '<i class="material-icons">check_circle</i>'

    //mask.appendChild(icon);
    this.renderer.appendChild(this.el.nativeElement, mask);
    this.renderer.addClass(this.el.nativeElement, 'selectable-element');
    this.renderer.addClass(mask, 'mask');
    //this.renderer.addClass(titleHolder, 'mask-title-holder');

    this.setDisplay();
  }

  private setDisplay():void{
    if(this._isChecked){
      this.renderer.addClass(this.el.nativeElement, 'checked');
    }else{
      this.renderer.removeClass(this.el.nativeElement, 'checked');
    }
  }

  ngOnDestroy(): void {

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/selectable-element.directive.ts